<template>
  <div class="settings-click-to-dial">
    <div class="click-to-dial ma-2">
      <click-to-dial />
    </div>
  </div>
</template>

<script>
import ClickToDial from '@/components/settings/click_to_dial'

export default {
  name: 'settings-click-to-dial',
  components: {
    ClickToDial
  }
}
</script>

<style></style>
